import { render, staticRenderFns } from "./AllNotifications.vue?vue&type=template&id=08e5c6ca&scoped=true"
import script from "./AllNotifications.vue?vue&type=script&lang=js"
export * from "./AllNotifications.vue?vue&type=script&lang=js"
import style0 from "./AllNotifications.vue?vue&type=style&index=0&id=08e5c6ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08e5c6ca",
  null
  
)

export default component.exports